import React, { useState } from 'react';
import { Form, Input, Select } from 'antd';
import { contactDetails } from '../../data/siteData';
import { submitContact } from '../../api';
import './ContactSection.css';

const SERVICES = [
  'Software Development',
  'Web Development',
  'Mobile App Development',
  'AI Solutions',
  'Cloud & DevOps',
  'API Integration',
  'Digital Marketing',
  'Training & Internship',
  'Other',
];

export default function ContactSection() {
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    setLoading(true);

    try {
      const result = await submitContact(values);

      if (result.status === 'success') {
        setDone(true);
        form.resetFields();
      } else {
        alert(result.message || 'Something went wrong!');
      }
    } catch (error) {
      console.error(error);
      alert('Something went wrong!');
    } finally {
      setLoading(false);
    }
  };

  const onReset = () => {
    setDone(false);
    form.resetFields();
  };

  return (
    <section className="contact-sec-light" id="contact">
      <div className="contact-bg-grid"></div>
      <div className="contact-glow-1"></div>
      <div className="contact-glow-2"></div>

      <div className="contact-wrap-light">
        {/* Left info column */}
        <div className="contact-info-col-light">
          <span className="contact-eyebrow-light">
            <span className="eyebrow-dot-light" /> GET IN TOUCH
          </span>

          <h2 className="contact-title-light">
            Let's Start Your<br />
            <span className="contact-title-gradient">Project Today</span>
          </h2>

          <p className="contact-desc-light">
            Fill out the form and our expert team will get back to you within 24 hours
            with a tailored proposal. Free consultation with zero obligation.
          </p>

          <div className="contact-details-light">
            {contactDetails.map((c, i) => (
              <div key={i} className="contact-detail-card-light">
                <div className="cdc-icon-light">{c.icon}</div>
                <div className="cdc-text-light">
                  <span className="cdc-label-light">{c.label}</span>
                  <span className="cdc-value-light">{c.value}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right form column */}
        <div className="contact-form-col-light">
          <div className="contact-form-card-light">
            {!done ? (
              <>
                <div className="form-card-header-light">
                  <h3>Send Us a Message</h3>
                  <p>We typically respond within a few hours during business days.</p>
                </div>

                <Form
                  form={form}
                  layout="vertical"
                  onFinish={onFinish}
                  requiredMark={false}
                  size="large"
                >
                  <div className="form-row-light">
                    <Form.Item
                      name="name"
                      label="Full Name"
                      rules={[
                        { required: true, message: 'Please enter your name' },
                        { min: 3, message: 'Name must be at least 3 characters' },
                      ]}
                    >
                      <Input placeholder="Your full name" />
                    </Form.Item>

                    <Form.Item
                      name="email"
                      label="Email Address"
                      rules={[
                        { required: true, message: 'Email is required' },
                        { type: 'email', message: 'Enter a valid email' },
                      ]}
                    >
                      <Input placeholder="you@company.com" />
                    </Form.Item>
                  </div>

                  <div className="form-row-light">
                    <Form.Item
                      name="phone"
                      label="Phone Number"
                      rules={[
                        { required: true, message: 'Phone number is required' },
                        {
                          pattern: /^[6-9]\d{9}$/,
                          message: 'Enter valid 10-digit mobile number',
                        },
                      ]}
                    >
                      <Input
                        placeholder="10-digit mobile number"
                        maxLength={10}
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Form.Item>

                    <Form.Item
                      name="service"
                      label="Service Needed"
                      rules={[{ required: true, message: 'Please select a service' }]}
                    >
                      <Select placeholder="Select a service">
                        {SERVICES.map(s => (
                          <Select.Option key={s} value={s}>{s}</Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>

                  <Form.Item
                    name="message"
                    label="Project Details"
                    rules={[
                      { required: true, message: 'Please describe your project' },
                      { min: 10, message: 'Please provide more details (min. 10 characters)' },
                    ]}
                  >
                    <Input.TextArea
                      rows={4}
                      placeholder="Tell us about your project, goals, budget, and timeline..."
                    />
                  </Form.Item>

                  <Form.Item style={{ marginBottom: 0 }}>
                    <button
                      type="submit"
                      className={`submit-btn-light${loading ? ' loading' : ''}`}
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <span className="spinner-light" /> Sending...
                        </>
                      ) : (
                        <>Send Message <span className="btn-arrow-light">→</span></>
                      )}
                    </button>
                  </Form.Item>
                </Form>
              </>
            ) : (
              <div className="success-view-light">
                <div className="success-circle-light">✅</div>
                <h3>Message Received!</h3>
                <p>
                  Thank you for reaching out. Our team will carefully review your project
                  requirements and get back to you within 24 hours.
                </p>
                <div className="success-meta-light">
                  <span>📧 Check your inbox for confirmation</span>
                </div>
                <button className="reset-btn-light" onClick={onReset}>
                  Send Another Message
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}